import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnDestroy
} from '@angular/core';

/**
 * Sets aria-label on the add-tab button in reuse-tab's extra content for screen readers.
 */
@Directive({
  selector: '[appReuseTabExtraAriaLabel]',
  standalone: false
})
export class ReuseTabExtraAriaLabelDirective implements AfterViewInit, OnDestroy {
  @Input() appReuseTabExtraAriaLabel = 'Add tab';

  private extraButton: HTMLButtonElement | null = null;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.updateButtonLabel();
  }

  ngOnDestroy(): void {
    this.extraButton = null;
  }

  private updateButtonLabel(): void {
    const label = this.appReuseTabExtraAriaLabel?.trim();
    if (!label) return;
    const findAndLabel = (): void => {
      const btn = this.el.nativeElement.querySelector?.('.ant-tabs-extra-content button.ant-btn');
      if (btn instanceof HTMLButtonElement && !btn.getAttribute('aria-label')) {
        this.extraButton = btn;
        btn.setAttribute('aria-label', label);
      }
    };
    findAndLabel();
    setTimeout(findAndLabel, 200);
  }
}
